import { render, staticRenderFns } from "./CustomChartRenderer.vue?vue&type=template&id=4120d141"
import script from "./CustomChartRenderer.vue?vue&type=script&lang=js"
export * from "./CustomChartRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports